import { PageKey } from '~/constants/page'
import { OrgAccount } from '~/utils/permission'

export default defineNuxtRouteMiddleware((to, from) => {
  const currentAccount = useUserInfo()

  const request = useRequestURL()

  const { meta: toMeta, name }: any = to

  /**
   * 私有化&纯净版数据
   */
  const { hasPagePermission } = usePageAndActionPermissionData()
  const permissionData = usePermissionData()

  const { permission, rights_type, user_id } = currentAccount?.value || {}

  // 个人中心相关页面
  const isCenter = to.fullPath.split('/')[1] === 'center'

  // 配置了权限
  if (toMeta?.permission && user_id) {
    let havePermission = (toMeta.permission as any)?.level.includes(
      Number(rights_type)
    )

    if (OrgAccount.includes(Number(rights_type))) {
      havePermission = (toMeta.permission as any)?.role.includes(
        Number(permission)
      )
    }

    if (!havePermission) {
      return navigateTo('/no-permission')
    }
  }

  const homeRoute = useHomeRoute()

  if (!hasPagePermission(name)) {
    if (to.name === PageKey.HOME || to.name === PageKey.RECENTLY_WORKS) {
      // 做一次针对首页的优化，防止无权限的用户每次进入首页都会跳转no-permission，以及从编辑器那边进来的（编辑器那边不知道首页是否有权限）
      return navigateTo(homeRoute)
    }

    return navigateTo('/no-permission')
  }

  if (isCenter && !user_id) {
    if (permissionData.value?.config?.logout_url) {
      return navigateTo(permissionData.value?.config.logout_url, {
        external: true,
      })
    } else {
      return navigateTo(
        `/login?redirect=${encodeURIComponent(request.origin + to.fullPath)}`
      )
    }
  }

  if (toMeta.track && import.meta.client) {
    trackEvent(toMeta.track, toMeta.trackParams?.(to))
  }
})
